import { graphql } from '~/__gql__/index';

export const mutationRequestReverseTrialUpsell = graphql(/* GraphQL */ `
  mutation RequestReverseTrialUpsell {
    requestReverseTrialUpsell
  }
`);
